import clsx from 'clsx';
import React from 'react';
import Icon from '../Icon/Icon';
import InputRadio from '../InputRadio/InputRadio';

type InputRadioThumbnailProps = {
  readonly 'aria-describedby'?: string;
  readonly 'aria-invalid'?: boolean;
  readonly 'aria-required'?: boolean;
  readonly checked?: boolean;
  /** Miniatura visual de la opción. Es decorativa: el nombre accesible sale de `label`. */
  readonly children: React.ReactNode;
  /** Clases de la caja de la miniatura (forma, tamaño, borde base): las pone el consumidor. */
  readonly className?: string;
  readonly disabled?: boolean;
  readonly id?: string;
  /** Nombre accesible de la opción. No se ve: la miniatura es la etiqueta visual. */
  readonly label: string;
  readonly name?: string;
  readonly onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  readonly value: string;
};

/**
 * InputRadioThumbnail - Un `InputRadio` cuya etiqueta visual es una miniatura (un avatar, una
 * pieza, una imagen). Mantiene el `<input type="radio">` nativo (Tab entra al grupo, flechas eligen)
 * y oculta el círculo: la miniatura seleccionada lleva borde de marca + check, y el anillo de foco
 * gris se pinta sobre la miniatura. Se usa dentro de un `RadioGroup` con `orientation="horizontal"`.
 */
function InputRadioThumbnail({ checked = false, children, className, label, ...props }: InputRadioThumbnailProps): JSX.Element {
  return (
    <InputRadio
      {...props}
      checked={checked}
      className="input-radio--thumbnail"
      label={
        <>
          <span aria-hidden="true" className={clsx('input-radio-thumbnail', className)}>
            {children}
            {checked && (
              <span className="input-radio-thumbnail__check">
                <Icon color="white" name="check" size="sm" />
              </span>
            )}
          </span>
          <span className="sr-only">{label}</span>
        </>
      }
    />
  );
}

export type { InputRadioThumbnailProps };
export default InputRadioThumbnail;
